import { useState } from 'react';

import { Button } from '@components/ui/button';

import { isSentryTestEnabled } from './init';

function throwSentryTestError(): never {
  throw new Error('Sentry test error (Fixxer Connect)');
}

export function SentryTestTrigger() {
  const [shouldThrow, setShouldThrow] = useState(false);

  if (!isSentryTestEnabled()) {
    return null;
  }

  if (shouldThrow) {
    throwSentryTestError();
  }

  return (
    <div className="fixed right-4 bottom-4 z-50">
      <Button onClick={() => setShouldThrow(true)} variant="destructive">
        Trigger Sentry test error
      </Button>
    </div>
  );
}
